import { useEffect, useMemo, useState } from "react";
import "./CategoriaBanner.css";
import { verificaAdmin } from "../../../components/utils/verificaAdmin";
import AdminCategoriaBanner from "./AdminCategoriaBanner/AdminCategoriaBanner";

export default function CategoriaBanner({ codgrupo }) {
    const [banners, setBanners] = useState([]);
    const [abrirAdmin, setAbrirAdmin] = useState(false);

    const isAdmin = verificaAdmin();

    async function carregarBanners() {
        try {
            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/home_media/listar",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
          //  console.log("banners", data)
            setBanners(data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        carregarBanners();
    }, []);

    const bannerCategoria = useMemo(() => {
        if (!banners.length || !codgrupo) return null;

        return banners.find(
            (b) =>
                b.localizacao === "categoriabanner" &&
                Number(b.ordem) === Number(codgrupo)
        );
    }, [banners, codgrupo]);



    const bannersCategoria = useMemo(() => {
        return banners.filter(
            (b) => b.localizacao === "categoriabanner"
        );
    }, [banners]);

   // console.log("Filtro banners", bannersCategoria)
    if (!bannerCategoria?.imagem) {
        return (
            <>
                {isAdmin && (
                    <>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button
                                className="btn-editar-categorias"
                                onClick={() => setAbrirAdmin(true)}
                            >
                                Editar
                            </button>
                        </div>

                        {abrirAdmin && (
                            <div
                                className="admin-modal-overlay"
                                onClick={() => setAbrirAdmin(false)}
                            >
                                <div
                                    className="admin-modal"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <AdminCategoriaBanner
                                        banners={bannersCategoria}
                                        onClose={() => setAbrirAdmin(false)}
                                        atualizarBanners={async () => {
                                            await carregarBanners();
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }

    return (
        <>
            {isAdmin && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <button
                        className="btn-editar-categorias"
                        onClick={() => setAbrirAdmin(true)}
                    >
                        Editar
                    </button>
                </div>
            )}

            {bannerCategoria?.imagem ? (
                <section className="categoria-banner">
                    <img
                        src={bannerCategoria.imagem}
                        alt={`Banner categoria ${codgrupo}`}
                    />
                </section>
            ) : (
                isAdmin && (
                    <section className="categoria-banner categoria-banner-admin">
                        <p>Banner da categoria {codgrupo}</p>
                    </section>
                )
            )}

            {abrirAdmin && (
                <div
                    className="admin-modal-overlay"
                    onClick={() => setAbrirAdmin(false)}
                >
                    <div
                        className="admin-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <AdminCategoriaBanner
                            banners={bannersCategoria}
                            onClose={() => setAbrirAdmin(false)}
                            atualizarBanners={async () => {
                                await carregarBanners();
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}